export const topServiceSlider = () => {
  const el = document.querySelector(".js-top-service-slider");
  if (!el) return;

  const SLIDE_COUNT = 6;
  const paginationEl = el.closest(".p-top-service__slider").nextElementSibling;

  const swiper = new Swiper(el, {
    slidesPerView: "auto",
    loop: true,
    centeredSlides: true,
    spaceBetween: 30,
    breakpoints: {
      1024: {
        spaceBetween: 60,
      },
    },
    autoplay: {
      delay: 5000,
    },
  });

  for (let i = 0; i < SLIDE_COUNT; i++) {
    const bullet = document.createElement("span");
    bullet.className = "swiper-pagination-bullet";
    if (i === 0) bullet.classList.add("swiper-pagination-bullet-active");
    paginationEl.appendChild(bullet);
  }

  swiper.on("slideChange", () => {
    const active = swiper.realIndex % SLIDE_COUNT;
    paginationEl
      .querySelectorAll(".swiper-pagination-bullet")
      .forEach((bullet, i) => {
        bullet.classList.toggle(
          "swiper-pagination-bullet-active",
          i === active,
        );
      });
  });

  paginationEl.addEventListener("click", (e) => {
    const bullet = e.target.closest(".swiper-pagination-bullet");
    if (!bullet) return;
    const index = [...paginationEl.children].indexOf(bullet);
    swiper.slideToLoop(index);
  });
};
